import { defineField } from '../fieldBuilder';

import type { RequestFieldDefinition } from '../types';

/** cooling-readiness — registry field list. */
export const COOLING_READINESS_FIELDS: readonly RequestFieldDefinition[] = [
  defineField(
    'cooling-readiness',
    'coolingInformation',
    0,
    'coolingIsExistingSystemOnsite',
    'Is there an existing cooling system onsite?',
    'Existing system',
  ),
  defineField(
    'cooling-readiness',
    'coolingInformation',
    1,
    'coolingIsChilledWaterAvailable',
    'Is chilled water available onsite?',
    'Chilled water',
  ),
  defineField(
    'cooling-readiness',
    'coolingInformation',
    2,
    'coolingTotalAvailableCapacityKw',
    'Total available cooling capacity (kW)',
    'Capacity',
  ),
  defineField(
    'cooling-readiness',
    'coolingInformation',
    3,
    'coolingDescription',
    'Description',
    'Description',
  ),
  defineField(
    'cooling-readiness',
    'coolingInformation',
    4,
    'coolingRequiredRedundancyForSystem',
    'Cooling Redundancy',
    'Redundancy',
  ),
  defineField(
    'cooling-readiness',
    'coolingInformation',
    5,
    'coolingTempRisePrefThroughItEquipment',
    'Temp rise pref through IT equipment (Rack ΔT)',
    'Rack ΔT',
  ),
  defineField(
    'cooling-readiness',
    'coolingInformation',
    6,
    'coolingDescribeApproach',
    'Describe cooling approach',
    'Approach',
  ),
  defineField(
    'cooling-readiness',
    'coolingInformation',
    7,
    'coolingRearDoorHexDesired',
    'Rear door heat exchanger desired?',
    'Rear door HX',
  ),
  defineField(
    'cooling-readiness',
    'coolingInformation',
    8,
    'coolingDescribeRearDoorLoop',
    'Describe rear door liquid loop',
    'Rear door loop',
  ),
  defineField(
    'cooling-readiness',
    'additionalInformation',
    0,
    'coolingAdditionalReadinessInfo',
    'Additional Cooling Readiness Information',
    'Notes',
  ),
];
